import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
  ExclamationCircleIcon
} from '@heroicons/react/24/outline';
import { BadgeProps } from 'lib/components/Badge';
import { SyncAttemptStatus } from 'lib/types/syncAttempt';
import { FC } from 'react';

export const SyncAttemptStatusMap: Record<
  SyncAttemptStatus,
  {
    badgeStatus: BadgeProps['status'];
    Icon: FC<{ className?: string }>;
    label: string;
  }
> = {
  [SyncAttemptStatus.SUCCESS]: {
    badgeStatus: 'success',
    Icon: CheckCircleIcon,
    label: 'Success'
  },
  [SyncAttemptStatus.IN_PROGRESS]: {
    badgeStatus: 'info',
    Icon: ClockIcon,
    label: 'In Progress'
  },
  [SyncAttemptStatus.SKIPPED]: {
    badgeStatus: 'warning',
    Icon: XCircleIcon,
    label: 'Skipped'
  },
  [SyncAttemptStatus.BAD_REQUEST]: {
    badgeStatus: 'warning',
    Icon: ExclamationTriangleIcon,
    label: 'Blocked'
  },
  [SyncAttemptStatus.INTERNAL_ERROR]: {
    badgeStatus: 'critical',
    Icon: ExclamationCircleIcon,
    label: 'Error'
  },
  [SyncAttemptStatus.EXTERNAL_ERROR]: {
    badgeStatus: 'critical',
    Icon: ExclamationCircleIcon,
    label: 'Error'
  }
};
